/* Reference SelBar (ported from vault-app), wired to our VaultCtx. */
import { useState } from "react";
import { useApp } from "./ctx";
import { getModelGlbUrl } from "@/features/vault/vaultApi";
import { downloadBlob } from "@/util/download";
import Ic from "./Ic";

export default function SelBar() {
  const { selected, clearSel, open, setBulkCount, setModalData } = useApp();
  const [busy, setBusy] = useState(false);
  const n = selected.length;

  // `selected` holds real model ids (FileCard selects by model._id). Download each
  // as its GLB via the same presigned-url → fetch → downloadBlob path PreviewModal uses.
  const download = async () => {
    if (!n || busy) return;
    setBusy(true);
    try {
      for (const id of selected) {
        try {
          const { url } = await getModelGlbUrl(id);
          const blob = await fetch(url).then((r) => r.blob());
          downloadBlob(blob, `${id}.glb`);
        } catch { /* model with no GLB — skip, keep downloading the rest */ }
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={"selbar" + (n ? " show" : "")}>
      <b>{n} selected</b>
      <button className="btn gold" onClick={() => { setBulkCount(n); open("bulk"); }}><Ic n="bolt" size={14} /> Render</button>
      <button className="btn sb-ghost" onClick={() => open("share")}>Share</button>
      <button className="btn sb-ghost" onClick={download} disabled={busy}>{busy ? "Downloading…" : "Download"}</button>
      {/* No collection context from a selection (this is the reverse flow) — clear any
          stale collectionId a previously-opened collection left in modalData so the modal
          shows its honest "open a collection first" state instead of silently adding these
          pieces to whatever collection was viewed last. */}
      <button className="btn sb-ghost" onClick={() => { setModalData("addItems", null); open("addItems"); }}>Collect</button>
      <button className="btn sb-ghost" style={{ padding: "7px 11px" }} onClick={clearSel}><Ic n="x" size={13} /></button>
    </div>
  );
}
